module.exports = __webpack_public_path__ + "static/media/prod4.02d7a076.jpg";